<template>

    <v-container>
        <v-form
                v-model="valid"
                class="mb-12">
            <v-row>
                <v-col align="center">

                    <Logo class="mb-10" />
                    <h5 class="headline mb-4">
                        <Dictionary v-if="showErrorNoTokenOrEmail" module="showErrorNoTokenOrEmail" string="title"/>
                        <Dictionary v-else module="resetPassword" string="title"/>
                    </h5>
                    <p>
                        <Dictionary v-if="showErrorNoTokenOrEmail" module="showErrorNoTokenOrEmail" string="subtitle"/>
                        <Dictionary v-if="!showErrorNoTokenOrEmail && !loading" module="resetPassword" string="subtitle"/>
                    </p>


                    <Button
                            v-if="showErrorNoTokenOrEmail"
                            block
                            @click="redirectToLogin()"
                    >
                      <Dictionary module="resetPassword" string="back_to_login_prompt" />
                    </Button>
                    <PasswordInput
                            v-if="!showErrorNoTokenOrEmail && !loading"
                            v-model="newPassword"
                            :rules="passwordRules"
                            autocomplete="new-password"
                            required
                            label="New Password"
                            :errorMessageState="errorMessage.state"
                    >
                    </PasswordInput>
                    <PasswordInput
                            v-if="!showErrorNoTokenOrEmail && !loading"
                            v-model="confirmPassword"
                            :rules="passwordRules"
                            autocomplete="new-password"
                            required
                            :errorMessageState="errorMessage.state"
                            :errorMessageValue="errorMessage.value"
                            label="Confirm Password"
                    >
                    </PasswordInput>
                    <Button
                            v-if="!showErrorNoTokenOrEmail"
                            :disabled="!valid"
                            block @click.prevent="resetButton()"
                            :loading="loading"
                    >

                      <Dictionary module="resetPassword" string="reset_password_button_prompt" />
                    </Button>

                </v-col>
            </v-row>
        </v-form>
    </v-container>

</template>


<script>


import Vue from 'vue';
import { mapGetters } from 'vuex';
import Dictionary from '../../components/Dictionary.vue';
import { passwordValueRequiredRule, passwordValidRule } from '../../helpers/rules/password';
import { emailValidRule, emailValueRequiredRule } from '../../helpers/rules/email';

export default Vue.extend({
  name: 'ResetPassword',
  data() {
    return {
      emailAddress: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
      valid: false,
      passwordRules: [
        passwordValueRequiredRule,
        passwordValidRule,
      ],
      emailRules: [
        emailValidRule,
        emailValueRequiredRule,
      ],
      errorMessage: {
        state: false,
        value: null,
      },
      showErrorNoTokenOrEmail: false,
    };
  },

  methods: {
    resetButton() {
      if (this.passwordsMatch) {
        this.loading = true;
        this.updatePassword();
      } else {
        this.errorMessage.state = true;
        this.errorMessage.value = 'Passwords do not match';
        this.valid = false;
      }
    },
    async updatePassword() {
      const data = {
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      };
      const response = await this.$store.dispatch('UPDATE_PASSWORD', data);
      this.loading = false;
      if (response.code === 200) {
        this.$router.push({ name: 'ResourcesPage' });
      }
    },
    async sendMagicLink() {
      this.loading = true;
      const data = {
        resetKey: this.$route.params.resetKey
      };
      const request = await this.$store.dispatch('PROCESS_MAGIC_LINK', data);
      if (request.code !== 201) {
        this.$router.push({ name: 'LoginPage' });
      } else {
        this.loading = false;
      }
    },
    redirectToLogin() {
      this.$router.push({ name: 'LoginPage' });
    },
  },

  computed: {
    ...mapGetters(['loginData']),
    passwordsMatch() {
      return this.newPassword === this.confirmPassword;
    },
  },


  watch: {
    newPassword() {
      if (this.errorMessage.state) {
        this.errorMessage.state = false;
        this.errorMessage.value = null;
      }
    },
    confirmPassword() {
      if (this.errorMessage.state) {
        this.errorMessage.state = false;
        this.errorMessage.value = null;
      }
    },
  },

  created() {
  },

  mounted() {
    if (this.$route.params.resetKey) {
      this.sendMagicLink();
    } else {
      this.showErrorNoTokenOrEmail = true;
    }
  },

  updated() {},
  components: {
    Dictionary,
  },
});
</script>


<style scoped>

</style>
